module.exports = __webpack_public_path__ + "img/212.8d11c3e9.png";